import React from "react";

// 모바일 카드 뷰에서 라벨+값을 작게 보여주는 공용 컴포넌트.
export default function MobileStatBox({ label, value, style }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '11px', color: '#888' }}>{label}</div>
      <div style={{ fontSize: '13px', fontWeight: 500, ...style }}>{value}</div>
    </div>
  );
}
